import { render, staticRenderFns } from "./AxCreateWorkspace.vue?vue&type=template&id=797881d9&scoped=true&"
import script from "./AxCreateWorkspace.vue?vue&type=script&lang=ts&"
export * from "./AxCreateWorkspace.vue?vue&type=script&lang=ts&"
import style0 from "./AxCreateWorkspace.vue?vue&type=style&index=0&id=797881d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797881d9",
  null
  
)

export default component.exports